<soft-list-page
  [resource]="timeReportsService"
  [emptyTemplate]="emptyState"
  (itemClick)="onItemClick($event)"
>
  <soft-page-header>
    <!--TODO-->
    <soft-meta-query-bar
      [metaForm]="queryMeta"
      [query]="query()"
      (queryChange)="setQuery($event)"
    ></soft-meta-query-bar>
  </soft-page-header>

  <ng-template let-item="item">
    <soft-ds-card density="compact" accent="primary" chevron>
      <soft-dynamic-object
        [definition]="$any(definition())"
        [value]="item"
      ></soft-dynamic-object>
    </soft-ds-card>
  </ng-template>
  <ng-template #emptyState>
    <div class="flex min-h-[45dvh] grow items-center justify-center">
      <soft-ds-empty-state
        title="Keine Arbeitsberichte"
        description="Für die gewählte Abfrage wurden keine Arbeitsberichte gefunden."
        actionLabel="Erneut abfragen"
        (action)="navigateToQueryPage()"
      />
    </div>
  </ng-template>
  <soft-page-footer>
    <div
      class="flex flex-col gap-1 px-4 py-3"
      style="background: var(--ds-surface-base)"
    >
      @for (sum of sums(); track sum) {
        <div class="flex flex-row justify-between items-center">
          <span class="ds-body-2-semibold">Gesamt</span>
          <span class="ds-body-2-semibold">
            {{ sum.duration | format: 'DURATION.DEFAULT' }}
          </span>
        </div>
      }
      @if (entryCount() === 0) {
        <div class="flex flex-row justify-between items-center">
          <span class="ds-body-2-semibold">Gesamt</span>
          <span class="ds-body-2 color-light">Keine Einträge</span>
        </div>
      } @else {
        <span class="ds-caption color-light">
          {{ entryCount() }} {{ entryCount() === 1 ? 'Eintrag' : 'Einträge' }}
        </span>
      }
    </div>
  </soft-page-footer>
</soft-list-page>
